import { LanguageCode } from "@/enums";
import { getTextResources } from "../../../tests/entities";
import { CheckoutInfo, OtpResponse, TextResourceList } from "@/entities";
import { getTranslations, loading, replaceState, translation } from "@/utils/common";
import { defineComponent } from "vue";
import { get } from "@/utils/httpRequest";
import { otpStore } from "@/store";

export default defineComponent({
    name: "ExpiredView",
    props: {
        scaSessionId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            language: LanguageCode.EN,
            countryCode: "EN",
            data: <CheckoutInfo | null>new CheckoutInfo(),
            textResourceList: new TextResourceList(),
            store: otpStore(),
            showBackButton: true,
        };
    },
    async created() {
        replaceState();
        this.data = this.store.otp;

        loading();
        try {
            const response = <OtpResponse>await get(`api/verifyotp/init/${this.scaSessionId}`);
            this.checkShowButton(response);

            //redirect to error view
            if (!response.isSuccess && response.view != "Expired") {
                this.$router.replace(`/${response.view}/${this.scaSessionId}`);
            }

            this.data = response.data ?? new CheckoutInfo();
        } catch (e) {
            console.log("Error while loading page data.", e);
        } finally {
            loading();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            loading();
            try {
                this.textResourceList = (await this.getTextResources(this.countryCode, this.language)) as TextResourceList;
            } catch {
                return;
            } finally {
                loading();
            }
        },
        redirectToMerchant() {
            if (this.data?.redirectUrl) {
                window.location.replace(this.data.redirectUrl);
            }
        },
        async getTextResources(countryCode: string | null | undefined, languageCode: LanguageCode, agent: unknown | null = null): Promise<TextResourceList | getTextResources> {
            const sysnameList = ["OtpExpiredTitle", "OtpExpiredDescription", "OtpReturnToShopButton"];

            return await getTranslations(sysnameList, countryCode, languageCode, agent);
        },
        getTranslation(sysName: string, replace: string[] = []): string {
            return translation(this.textResourceList?.textResourceItems, sysName, replace);
        },
        checkShowButton(otp: OtpResponse) {
            if (otp.data?.redirectExpiry == null) {
                return;
            }

            const redirectExpiry = otp.data.redirectExpiry;
            const expiryDate = new Date(redirectExpiry);
            const currentDate = new Date();
            this.showBackButton = currentDate < expiryDate;

            if (this.showBackButton) {
                setTimeout(() => {
                    this.checkShowButton(otp);
                }, 1000);
            }
        },
    },
});
